import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { T, TF } from "react-translator-component";
import { Avatar, Box, ListItem, Typography } from "@mui/material";
import GCBackButton from "../components/GreenCity/GCBackButton";
import UserCardList from "../components/Models/GreenCity/UserCardList";
import LoadingModal from "../components/LoadingModal";
import appServices from "../services/app-services/appServices";
import { isMemberRole } from "../util/utils";

const ApprovedMemberList = () => {
  const navigate = useNavigate();
  const { user } = useSelector((state: any) => state.userAuth);
  const groupId = useLocation().state.groupId
  const [groupInfo, setGroupInfo] = useState<any>([]);
  const [members, setMembers] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [myRole, setMyRole] = useState<string>("");
  const [leaders, setLeaders] = useState<any[]>([]);
  const [totalMembers, setTotalMembers] = useState<number>();
  const [groupIcon, setGroupIcon] = useState<File>();

  useEffect(() => {
    if (!groupId) return
    getGroupInfo();
    getGroupIcon();
  },[groupId])

  const getGroupInfo = async () => {
    try {
      setLoading(true)
      const res = await appServices.getMembersGroup(groupId)
      const groupData = res.member_group
      const approvedMemberList = groupData.member_group_users.filter((member: any) => member.status === "approved")
      setTotalMembers(approvedMemberList.length);
      categorizeGroupUsers(approvedMemberList)
      setGroupInfo(groupData)
    } catch (error: any) {
      console.error(error)
    } finally {
      setLoading(false)
    }
  }

  const getGroupIcon = async () => {
    try {
      const blob = await appServices.getGroupIcon(groupId)
      const file = new File([blob], groupInfo.group_icon, { type: blob.type });
      setGroupIcon(file);
    } catch (error: any) {
      console.error("Failed to get group icon image")
    } finally {
      setLoading(false)
    }
  }

  const categorizeGroupUsers = (memberGroupUsers: any[]) => {
    const mem: any[] = [];
    const lead: any[] = [];

    memberGroupUsers.forEach((memberGroupUser: any) => {
      if (memberGroupUser.id === user.id) {
        setMyRole(memberGroupUser.group_role);
      }

      if (isMemberRole(memberGroupUser.group_role)) {
        mem.push(memberGroupUser);
      } else {
        lead.push(memberGroupUser);
      }
    })
    if(!myRole) setMyRole("Leader")
    setMembers(mem);
    setLeaders(lead);
  }

  return (
    <Box>
      <Box style={style.headerContainer}>
        <GCBackButton onClick={() => navigate(-1)} />
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            paddingRight: "10px",
          }}
        >
          <Box style={style.eventPostingBox}>
            <Box component="div" style={style.eventPostingIcon}>
              <Avatar
                src={groupIcon ? URL.createObjectURL(groupIcon) : ''}
                sx={{ width: 30, height: 30 }}
              />
            </Box>
            <Typography style={{ fontWeight: "700", marginTop: "5px" }}>{T("group_member")}</Typography>
          </Box>
        </Box>
      </Box>
      <Box style={style.totalCount}>{TF(T("member_list_approved_member_list"), totalMembers ? totalMembers + 1 : 0)}</Box>

      <Typography sx={{ textAlign: "left", marginLeft: "15px" }}>{T("members_with_roles")}</Typography>

      <Box sx={{ marginBottom: "20px" }}>
        <ListItem disableGutters>
          {/* グループのリーダー */}
          <UserCardList
            targetUser={groupInfo?.owner}
            role={"leader"}
            myRole={myRole}
            groupInfo={groupInfo}
          />
        </ListItem>
        {/* グループのサブリーダー または 会計 */}
        {leaders.map((leader, index) => (
          <ListItem disableGutters key={`executives_${index}`}>
            <UserCardList
              targetUser={leader}
              role={leader?.group_role}
              myRole={myRole}
              groupInfo={groupInfo}
            />
          </ListItem>
        ))}
      </Box>

      {!loading && members.length > 0 && (
        <Box sx={{ marginBottom: "20px" }}>
          <Typography sx={{ textAlign: "left", marginLeft: "15px" }}>{T("member")}</Typography>
          {members?.map((member: any, index: number) => {
            return (
              <Box key={`member_${index}`}>
                {/* グループの一般メンバー */}
                <ListItem disableGutters>
                  <UserCardList
                    targetUser={member}
                    role={member?.group_role}
                    myRole={myRole}
                    groupInfo={groupInfo}
                  />
                </ListItem>
              </Box>
            );
          })}
        </Box>
      )}
      <LoadingModal visible={loading} />
    </Box>
  );
};
const style = {
  eventPostingIcon: {
    borderRadius: "50%",
    padding: "3px 6px 3px 6px",
    color: "white",
  },
  eventPostingBox: {
    display: "flex",
    gap: "15px",
    alignItmes: "center",
    paddingTop: "10px",
    paddingLeft: "10px",
  },
  totalCount: {
    backgroundColor: "#F4F4F4",
    marginTop: 20,
    marginLeft: 15,
    marginRight: 15,
    marginBottom: 20,
    borderRadius: 10,
    padding: "15px 10px 15px 10px",
  },
  headerContainer: {
    paddingTop: 100,
    paddingLeft: 16,
    paddingRight: 16,
    paddingBottom: "12px",
    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.3)",
  },
};
export default ApprovedMemberList;
